import { Deserializable } from '../protocols/deserializable';
import { EmployerSubmissionTypeEnum } from '../users/enum/employer-submission-type.enum';

export class EmployerSubmissionType implements Deserializable {
  public id!: EmployerSubmissionTypeEnum;
  public name!: string;
  public idSuffix!: string;
  public effort!: number;
  public daysBeforeOverdue!: number;

  onDeserialize() {}
}
